/**
 * @generated SignedSource<<dff7c166d1abd84392f1df3e5b55db09>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type plusSecondaryContentItemContent$data = {
  readonly __typename: string;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink" | "helpersCheckIsPlusArticle" | "hooksContentItemProvidersContent" | "plusArticleTypeTitleContent">;
  readonly " $fragmentType": "plusSecondaryContentItemContent";
};
export type plusSecondaryContentItemContent$key = {
  readonly " $data"?: plusSecondaryContentItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"plusSecondaryContentItemContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "plusSecondaryContentItemContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "plusArticleTypeTitleContent"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersCheckIsPlusArticle",
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PaywallType",
              "kind": "LinkedField",
              "name": "paywallTypes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "entityUuid",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "Article",
          "abstractKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "withActionBar",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withHeadline",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withPublishedDate",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withSections",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withSubHeadline",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withSummary",
          "value": true
        }
      ],
      "kind": "FragmentSpread",
      "name": "hooksContentItemProvidersContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "a9141c261db40d6b3ff21036dbb3ca08";

export default node;
